import { render, staticRenderFns } from "./Login3.vue?vue&type=template&id=638d4eec&scoped=true&"
import script from "./Login3.vue?vue&type=script&lang=js&"
export * from "./Login3.vue?vue&type=script&lang=js&"
import style0 from "./Login3.vue?vue&type=style&index=0&id=638d4eec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638d4eec",
  null
  
)

export default component.exports